module.exports = __webpack_public_path__ + "static/media/mastercard.00e02b9b.webp";